import { Component, OnInit, ViewChild } from '@angular/core';
import { IonNav, NavParams } from '@ionic/angular';

@Component({
  selector: 'app-nav-modal-base',
  templateUrl: './nav-modal-base.component.html',
  styleUrls: ['./nav-modal-base.component.scss'],
})
export class NavModalBaseComponent implements OnInit {

  @ViewChild('modalNav', {static: true}) nav: IonNav;
  
  constructor(private navParams: NavParams) { }

  ngOnInit() {
    this.nav.setRoot(this.navParams.get('rootPage'));
  }

}
